<!--suppress ALL -->
<!--suppress ALL -->
<template>
  <detailTemplate
    :classCustom="[tabHistory ? 'detailShowHistory' : '', 'detail-docs']"
  >
    <template #content>
      <transition name="el-fade-in-linear">
        <el-tooltip content="Lịch sử tác động" placement="left">
          <div
            v-show="!tabHistory"
            @click="openTabHistory"
            class="btn-show-history clickable flex-row flex__center border-radius__50"
          >
            <el-badge is-dot class="inline-flex">
              <i class="icon-small fal fa-comment-alt-smile"></i>
            </el-badge>
          </div>
        </el-tooltip>
      </transition>
      <i
        @click="backListPage"
        class="back-icon border-radius fal fa-arrow-right"
      ></i>
      <div class="header">
        <div class="docTags">
          <el-tag
            size="mini"
            class="priority lv3"
            v-if="outgoingDoc.docTypeName"
          >
            {{ outgoingDoc.docTypeName }}
          </el-tag>
          <el-tag
            v-if="outgoingDoc.priorityId"
            size="mini"
            :class="['priority', `${getPriorityClass(outgoingDoc.priorityId)}`]"
          >
            <i class="fas fa-bolt"></i>
            {{ outgoingDoc.priorityName }}
          </el-tag>
        </div>
        <h4 class="title-name">
          <break-word-span
            :text="outgoingDoc.quote"
            :maxLength="100"
          ></break-word-span>
        </h4>

        <div class="file-uploaded margin-top-10 flex-row" style="max-width: 250px">
          <div
            class="file clickable flex-row flex__between padding-left-10"
            @click="downloadDoc(referenceOutgoingAttachment || signatureFile || vbAttachment)"
          >
            <file-type-image :custom-class="'icon-small margin-right-10'" :file-extention="'pdf'"/>
            <span class="fileName font-weight_normal color__white">Xem nội dung văn bản</span>
            <a class="clickable icon-download-file margin-left-10">
              <i class="fas fa-cloud-download color__white font-size__medium"></i>
            </a>
          </div>
          <div class="file-uploaded flex-row">
            <div
              class="file file-wa clickable flex-row flex__between padding-left-10 margin-left-10"
              @click="downloadOriginDoc(signatureFile || vbAttachment)"
            >
              <file-type-image :custom-class="'icon-small margin-right-10'" :file-extention="'pdf'" />
              <span class="fileName font-weight_normal color__white">Xem nội dung văn bản gốc</span>
              <a class="clickable icon-download-file margin-left-10">
                <i class="fas fa-cloud-download color__white font-size__medium"></i>
              </a>
            </div>
          </div>
        </div>
      </div>

      <VuePerfectScrollbar class="scroll-area" :settings="settings">
        <div class="body">
          <div class="group__info margin-top-10 padding-bottom-10">
            <div class="title font-size__medium">Thông tin</div>
            <div class="ctn">
              <div class="list-info width__100">
                <div
                  class="item flex-row flex__left margin-bottom-10"
                  v-if="outgoingDoc.docCode"
                >
                  <div class="label font-size__small txt-right">
                    Số ký hiệu:
                  </div>
                  <div class="content width__100 has-border__bottom">
                    {{ outgoingDoc.docCode || "-" }}
                  </div>
                </div>
                <div
                  class="item flex-row flex__left margin-bottom-10"
                  v-if="outgoingDoc.docDate"
                >
                  <div class="label font-size__small txt-right">
                    Ngày văn bản:
                  </div>
                  <div class="content width__100 has-border__bottom">
                    {{
                    outgoingDoc.docDate
                    | dateFormatter({
                    nullValue: "-",
                    dateFormat: "DD/MM/YYYY"
                    })
                    }}
                  </div>
                </div>

                <div class="item flex-row flex__left margin-bottom-10">
                  <div class="label font-size__small txt-right">
                    Hạn xử lý:
                  </div>
                  <div class="content width__100 has-border__bottom">
                    {{
                    outgoingDoc.deadlineDate
                    | dateFormatter({
                    nullValue: "-",
                    dateFormat: "DD/MM/YYYY HH:mm"
                    })
                    }}
                  </div>
                </div>

                <div class="item flex-row flex__left margin-bottom-10">
                  <div class="label font-size__small txt-right">
                    Đơn vị ban hành:
                  </div>
                  <div class="content width__100 has-border__bottom">
                    {{ outgoingDoc.publisherName || "-" }}
                  </div>
                </div>

                <div
                  class="item flex-row flex__left margin-bottom-10"
                  v-if="
                    docStatus === OUTGOING_DOC_STATUS.CHO_BAN_HANH ||
                      docStatus === OUTGOING_DOC_STATUS.DABANHANH
                  "
                >
                  <div class="label font-size__small txt-right">
                    Người ký duyệt:
                  </div>
                  <div class="content width__100 has-border__bottom">
                    {{ signerName || "-" }}
                  </div>
                </div>

                <div class="item flex-row flex__left margin-bottom-10">
                  <div class="label font-size__small txt-right">
                    Đơn vị thực hiện:
                  </div>
                  <div class="content width__100 has-border__bottom">
                    {{ outgoingDoc.deptEditorName || "-" }}
                  </div>
                </div>

                <div class="item flex-row flex__left margin-bottom-10">
                  <div class="label font-size__small txt-right">
                    Số trang/ Số bản:
                  </div>
                  <div class="content width__100 has-border__bottom">
                    {{ outgoingDoc.numberOfPage || "-" }} /
                    {{ outgoingDoc.numberOfCopy || "-" }}
                  </div>
                </div>

                <!--nơi nhận bên trong-->
                <div class="item flex-row flex__left margin-bottom-10">
                  <div class="label font-size__small txt-right">
                    Nơi nhận bên trong:
                  </div>
                  <div class="content width__100 has-border__bottom">
                    <p v-if="!docReceivers || !docReceivers.length">-</p>
                    <div v-else class="flex-col flex__left">
                      <p
                        v-for="docReceiver in docReceivers"
                        v-bind:key="docReceiver.id"
                        :class="[
                          'index' !== docReceivers.length - 1
                            ? 'margin-bottom-10'
                            : ''
                        ]"
                      >
                        {{ docReceiver.objectName }}
                      </p>
                    </div>
                  </div>
                </div>
                <!--nơi nhận bên trong:end-->

                <!--nơi nhận bên ngoài-->
                <div class="item flex-row flex__left margin-bottom-10">
                  <div class="label font-size__small txt-right">
                    Nơi nhận bên ngoài:
                  </div>
                  <div class="content width__100 has-border__bottom">
                    <!-- doi voi cac du lieu moi thi hien thi kieu nay-->
                    <div
                      class="flex-col flex__left"
                      v-if="receiveOtherDepts && receiveOtherDepts.length"
                    >
                      <p
                        class="margin-bottom-10"
                        v-for="receiveOtherDept in receiveOtherDepts"
                        :key="receiveOtherDept.id"
                      >
                        {{ receiveOtherDept.objectName }}
                      </p>
                    </div>
                    <!-- doi voi cac du lieu moi thi hien thi kieu nay:end-->
                    <!-- doi voi cac du lieu cu thi hien thi kieu nay-->
                    <div
                      v-else-if="outgoingDoc && outgoingDoc.otherReceivePlaces"
                      class="flex-col flex__left"
                    >
                      <p
                        v-for="otherReceivePlace in outgoingDoc.otherReceivePlaces.split(
                          ','
                        )"
                        :key="otherReceivePlace"
                        class="margin-bottom-10"
                      >
                        {{ otherReceivePlace || "-" }}
                      </p>
                    </div>
                    <!-- doi voi cac du lieu cu thi hien thi kieu nay:end-->
                    <p v-else class="txt__left">-</p>
                  </div>
                </div>
                <!--nơi nhận bên ngoài:end-->

                <!--nơi nhận trên trục liên thông-->
                <div
                  class="item flex-row flex__left margin-bottom-10"
                  v-if="isBanHanhTrucLienThong"
                >
                  <div class="label font-size__small txt-right">
                    Nơi nhận trên trục liên thông văn bản
                  </div>
                  <div class="content width__100 has-border__bottom">
                    <p v-if="!agencies || !agencies.length">-</p>
                    <div v-else class="flex-col flex__left">
                      <p
                        v-for="agency in agencies"
                        v-bind:key="agency.id"
                        :class="[
                          'index' !== agencies.length - 1
                            ? 'margin-bottom-10'
                            : ''
                        ]"
                      >
                        {{ agency.objectName }}
                      </p>
                    </div>
                  </div>
                </div>
                <!--nơi nhận trên trục liên thông:end-->

                <div
                  class="item flex-row flex__left margin-bottom-10"
                  v-if="isBanHanhTrucLienThong"
                >
                  <div class="label font-size__small txt-right">
                    Văn bản quy phạm pháp luật
                  </div>
                  <div class="content width__100 has-border__bottom">
                    <el-checkbox
                      :border="false"
                      v-model="isLawDocument"
                      class="style-fullWidth"
                      :disabled="true"
                    ></el-checkbox>
                  </div>
                </div>

                <div
                  class="item flex-row flex__left margin-bottom-10"
                  v-if="isBanHanhTrucLienThong"
                >
                  <div class="label font-size__small txt-right">
                    Loại chỉ đạo
                  </div>
                  <div class="content width__100 has-border__bottom">
                    {{ steeringTypeLabel || "-" }}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <doc-relations-detail
            ref="docRelationsNoAttachedDetail"
            :title="'Văn bản liên quan không ban hành kèm'"
            :doc-id="id"
            :isForBlockedRole="true"
            :attached-type="DOC_RELATION_ATTACHED_TYPE.NO_ATTACHED"
          ></doc-relations-detail>

          <doc-relations-detail
            ref="docRelationsAttachedDetail"
            :title="'Văn bản liên quan ban hành kèm'"
            :doc-id="id"
            :isForBlockedRole="true"
            :attached-type="DOC_RELATION_ATTACHED_TYPE.ATTACHED"
          ></doc-relations-detail>

          <phieu-y-kien-detail
            :title="'Phiếu ý kiến'"
            :doc-id="id"
            :categoryCode="outgoingDoc.docTypeCode"
          ></phieu-y-kien-detail>

          <vbdi-luongxuly-wrapper
            :id="id"
            :isForBlockedRole="true"
          />
        </div>
      </VuePerfectScrollbar>

      <div class="footer" v-if="!isAchievement">
        <div class="flex-row flex__left form-button__action">
          <el-button
            class="detailBtn detailBtnPrimary"
            @click="isOpenDocOutSelectHandlerDialog = true"
            v-if="isEnableChuyenXuLi() && !isViewAsUyQuyen"
          >
            <i class="fas fa-arrow-alt-to-right font-size__small"></i>
            <span v-if="step == null || step.signType != 2"
            >&nbsp;Chuyển phê duyệt</span
            >
            <span v-else-if="step && step.signType == 2"
            >&nbsp;Ký số và Chuyển xử lý</span
            >
          </el-button>
          <el-button
            class="detailBtn detailBtnSecondary"
            v-if="isEnableKetThuc() && !isViewAsUyQuyen"
            @click="isOpenDocOutKetThucDialog = true"
          >
            <i class="fas fa-check-circle font-size__small"></i>
            <span v-if="step == null || step.signType != 2"
            >&nbsp;Phê duyệt</span
            >
            <span v-else-if="step && step.signType == 2">&nbsp;Ký duyệt</span>
          </el-button>

          <el-button
            class="detailBtn detailBtnAlert"
            v-if="isChoXuLy() && !isViewAsUyQuyen"
            @click="tuChoi()"
          >
            <i class="fas fa-ban font-size__small"></i>
            &nbsp;Từ chối
          </el-button>

          <el-button
            class="detailBtn detailBtnAlert"
            v-if="isEnableTuChoiBanHanh()"
            @click="tuChoiBHanh()"
          >
            <i class="fas fa-ban font-size__small"></i>
            &nbsp;Từ chối
          </el-button>

          <el-button
            class="detailBtn detailBtnSecondary"
            v-if="false"
            @click="isOpenOutgoingDocProcessThuHoiDialog = true"
          >
            <i class="fas fa-undo font-size__small"></i>
            &nbsp;Thu hồi
          </el-button>

          <el-button
            class="detailBtn detailBtnSecondary"
            v-if="false"
            @click="isOpenOutgoingDocThuHoiDialog = true"
          >
            <i class="fas fa-undo font-size__small"></i>
            &nbsp;Thu hồi
          </el-button>

          <el-button
            class="detailBtn detailBtnSecondary"
            v-if="false"
            @click="isOpenOutgoingDocDBHThuHoiDialog = true"
          >
            <i class="fas fa-undo font-size__small"></i>
            &nbsp;Thu hồi
          </el-button>

          <el-button
            class="detailBtn detailBtnPrimary"
            v-if="false"
            @click="isOpenBHanhDocOut = true"
          >
            <i class="fas fa-file-export font-size__small"></i>
            &nbsp;Ban hành
          </el-button>

          <el-button
            class="detailBtn detailBtnPrimary"
            v-if="false"
            @click="suaSaiBanHanh"
          >
            <i class="fas fa-check font-size__small"></i>
            Sửa sai
          </el-button>

          <el-button
            class="detailBtn detailBtnPrimary"
            v-if="false"
            @click="hieuChinhVb()"
          >
            <i class="fas fa-file-export font-size__small"></i>
            &nbsp;Hiệu chỉnh & ban hành
          </el-button>

          <el-button
            class="detailBtn btn__delete btn-none__border color__white bg__red"
            @click="delete_()"
            v-if="false"
          >
            <i class="fas fa-trash font-size__small"></i>&nbsp; Xóa văn bản
          </el-button>
          <el-button
            class="detailBtn detailBtnSecondary"
            v-if="false"
            @click="openCCDialog()"
          >
            <i class="fas fa-share-all font-size__small"></i>
            &nbsp;CC
          </el-button>

          <el-button
            class="detailBtn detailBtnPrimary"
            @click="openGiaoViecDialog"
            v-if="false"
          >
            <i class="fas fa-fast-forward font-size__small"></i>
            Giao việc
          </el-button>

          <el-button
            class="detailBtn detailBtnPrimary"
            @click="exportTiepNhanVanBanReport"
            v-if="false"
          >
            <i class="fas fa-fast-forward font-size__small"></i>
            Báo cáo tiếp nhận
          </el-button>
        </div>

        <div class="flex-row flex__right">
          <listIconAction :docId="id"/>
        </div>
      </div>
      <div class="footer" v-else>
        <div class="flex-row flex__left form-button__action">
          <el-button class="detailBtn detailBtnPrimary" @click="restore">
            <i class="fas fa-undo font-size__small"></i>
            Phục hồi
          </el-button>

          <el-button class="detailBtn detailBtnAlert" @click="permanentDelete">
            <i class="fas fa-trash font-size__small"></i>
            Xóa văn bản
          </el-button>
        </div>
      </div>

      <transition name="slide">
        <history-docout
          :vbOutgoingDocId="id"
          :isEnableComment="false"
          :isForBlockedRole="true"
          v-show="tabHistory"
          @closeHistory="closeTabHistory"
        ></history-docout>
      </transition>

      <!-- dialog chon nguoi xu ly -->
      <DocOutSelectHandler
        :isOpen="isOpenDocOutSelectHandlerDialog"
        :quote="outgoingDoc.quote"
        :outgoingProcessId="userVbOutgoingProcessId"
        @closeDialog="isOpenDocOutSelectHandlerDialog = false"
        @closed="isEnableDocOutSelectHandlerDialog = false"
        @success="chuyenXuLiSuccess"
        v-if="isEnableDocOutSelectHandlerDialog"
      />

      <!-- dialog ket thuc -->
      <DocOutKetThuc
        :isOpen="isOpenDocOutKetThucDialog"
        :docId="id"
        :vbOutgoingProcessId="userVbOutgoingProcessId"
        v-if="isEnableDocOutKetThucDialog"
        @dialogClosed="isEnableDocOutKetThucDialog = false"
        @closeDialog="isOpenDocOutKetThucDialog = false"
        @success="banHanhSuccess"
      />

      <outgoingDocThuHoiDialog
        :isOpen="isOpenOutgoingDocThuHoiDialog"
        :vbOutgoingDocId="id"
        v-if="isEnableOutgoingDocThuHoiDialog"
        @dialogClosed="isEnableOutgoingDocThuHoiDialog = false"
        @closeDialog="isOpenOutgoingDocThuHoiDialog = false"
      />
      <!-- dialog tu choi -->

      <DocOutTuChoi
        :isOpen="isOpenDocOutTuChoiDialog"
        :docId="id"
        :outgoingProcessId="userVbOutgoingProcessId"
        :listImageChange="listImageChange"
        v-if="isEnableDocOutTuChoiDialog"
        @closeDialog="isOpenDocOutTuChoiDialog = false"
        @closed="isEnableDocOutTuChoiDialog = false"
        @tuChoiSuccess="tuChoiSuccess"
      />
      <!-- dialog tu choi -->

      <DocOutTuChoiBanHanh
        :isOpen="isOpenDocOutTuChoiBHanhDialog"
        :docId="id"
        v-if="isEnableDocOutTuChoiBHanhDialog"
        @closeDialog="isOpenDocOutTuChoiBHanhDialog = false"
        @closed="isEnableDocOutTuChoiBHanhDialog = false"
        @tuChoiSuccess="tuChoiBHanhSuccess"
      />

      <!-- ban hành văn bản -->
      <BHanhDocOutDialog
        :isOpen="isOpenBHanhDocOut"
        :quote="outgoingDoc.quote"
        :docId="id"
        :docTypeId="outgoingDoc.docTypeId"
        :docStatus="outgoingDoc.status"
        :deptEditorId="outgoingDoc.deptEditorId"
        :publisherId="outgoingDoc.publisherId"
        :docReceiverIds="docReceiverIds"
        :otherReceivePlaces="outgoingDoc.otherReceivePlaces"
        v-if="isEnableBHanhDocOut"
        @closed="isEnableBHanhDocOut = false"
        @closeDialog="isOpenBHanhDocOut = false"
        @success="banHanhVanThuSuccess"
      />

      <!-- CC văn bản -->
      <CCDocOut
        :isOpen="isOpenDocOutCCDialog"
        :docId="id"
        :docTitle="outgoingDoc.quote"
        @closeDialog="isOpenDocOutCCDialog = false"
        @closed="isEnableDocOutCCDialog = false"
        v-if="isEnableDocOutCCDialog"
        @success="ccSuccess"
      />

      <outgoingDocProcessThuHoiDialog
        :isOpen="isOpenOutgoingDocProcessThuHoiDialog"
        :vbOutgoingProcessId="userVbOutgoingProcessId"
        v-if="isEnableOutgoingDocProcessThuHoiDialog"
        @dialogClosed="isEnableOutgoingDocProcessThuHoiDialog = false"
        @closeDialog="isOpenOutgoingDocProcessThuHoiDialog = false"
        @success="outGoingProcessThuHoiSuccess"
      />

      <outgoingDocThuHoiDialog
        :isOpen="isOpenOutgoingDocThuHoiDialog"
        :vbOutgoingDocId="id"
        v-if="isEnableOutgoingDocThuHoiDialog"
        @dialogClosed="isEnableOutgoingDocThuHoiDialog = false"
        @closeDialog="isOpenOutgoingDocThuHoiDialog = false"
      />

      <outgoingDocDBHThuHoiDialog
        :isOpen="isOpenOutgoingDocDBHThuHoiDialog"
        :vbOutgoingDocId="id"
        v-if="isEnableOutgoingDocDBHThuHoiDialog"
        @closed="isEnableOutgoingDocDBHThuHoiDialog = false"
        @closeDialog="isOpenOutgoingDocDBHThuHoiDialog = false"
      />
      <!--note in doc-->
      <DialogNoteInDocs
        v-if="isOpenNoteInDocDialog"
        :isOpen="isOpenNoteInDocDialog"
        :vbAttachmentId="vbAttachment.id"
        :isWatchingNote="false"
        :isAddSignature="false"
        :docId="id"
        @finishNoteDoc="finishNoteDoc"
        @closed="isEnableNoteInDocDialog = false"
        @closeDialog="isOpenNoteInDocDialog = false"
      />
      <!--add chu ky-->
      <DialogNoteInDocs
        v-if="isOpenAddSignatureDialog"
        :isOpen="isOpenAddSignatureDialog"
        :vbAttachmentId="vbAttachment.id"
        :isWatchingNote="false"
        :isAddSignature="true"
        :docId="id"
        @addSignatureSuccess="addSignatureSuccess"
        @closed="isEnableAddSignatureDialog = false"
        @closeDialog="isOpenAddSignatureDialog = false"
      />

      <task-create-dialog
        :isOpen="isOpenCreateJobDialog"
        :taskType="TASK_TASK_TYPE.GIAOVIEC"
        :viewType="JOB_INDEX_PAGE.ASSIGNER"
        :docId="id"
        :docType="DOC_TYPE.VB_DI"
        v-if="isEnableCreateJobDialog"
        @dialogClosed="isEnableCreateJobDialog = false"
        @closeDialog="isOpenCreateJobDialog = false"
        @success="createTaskSuccess"
      />

      <vb-outgoing-doc-sua-sai-bh-dialog
        :isOpen="isOpenSuaSaiDialog"
        :id="id"
        v-if="isEnableSuaSaiDialog"
        @dialogClosed="isEnableSuaSaiDialog = false"
        @closeDialog="isOpenSuaSaiDialog = false"
        @updateSuccess="suaSaiSuccess"
      >
      </vb-outgoing-doc-sua-sai-bh-dialog>
    </template>
  </detailTemplate>
</template>
<script>
  import VuePerfectScrollbar from "vue-perfect-scrollbar";
  import constants from "../../../constants";
  import {EventBus} from "../../../event-bus.js";
  import buildAttachmentURL from "../../../filters/buildAttachmentURL.js";
  import convertToLabelFilter from "../../../filters/convertToLabelFilter";
  import dateFormatter from "../../../filters/dateFormatter";
  import errorMessageFilter from "../../../filters/errorMessageFilter";
  import vbAttachmentTokenMixin from "../../../mixins/vbAttachmentTokenMixin";
  import attachmentService from "../../../services/attachmentService";
  import categoryViewService from "../../../services/categoryViewService";
  import docRelationService from "../../../services/docRelationService";
  import h from "../../../services/h";
  import menuConfigService from "../../../services/menuConfigService";
  import outgoingDocService from "../../../services/outgoingDocService";
  import utils from "../../../services/utils";
  import vbAttachmentTokenService from "../../../services/vbAttachmentTokenService";
  import vbDelegateInfoService from "../../../services/vbDelegateInfoService";
  import vbFlowInstanceService from "../../../services/vbFlowInstanceService.js";
  import vbOutgoingDocReceiversService from "../../../services/vbOutgoingDocReceiversService";
  import vbOutgoingProcessService from "../../../services/vbOutgoingProcessService.js";
  import vbStepService from "../../../services/vbStepService";
  import BreakWordSpan from "../../adminstration/ketluan/break-word-span";
  import FileTypeImage from "../../common/FileTypeImage";
  import handleRequestErrorMixin from "../../handleRequestErrorMixin";
  import TaskCreateDialog from "../../job/create-job/task-create-dialog";
  import BHanhDocOutDialog from "../components/BHanhDocOutDialog";
  import CCDocOut from "../components/CCDocOut";
  import DocOutKetThuc from "../components/DocOutKetThuc";
  import DocOutTuChoi from "../components/DocOutTuChoi";
  import DocOutTuChoiBanHanh from "../components/DocOutTuChoiBHanh";
  import DocRelationsDetail from "../doc-relations-detail";
  import HistoryDocout from "../History";
  import PhieuYKienDetail from "../phieu-ykien-detail";
  import VbOutgoingDocSuaSaiBhDialog from "../vb-outgoing-doc-sua-sai-bh-dialog";
  import VbdiDownloadFiles from "../vbdi-download-files";
  import VbdiLuongxulyWrapper from "../vbdi-luongxuly-wrapper";
  import downloadService from "../../../services/downloadService";

  export default {
    mixins: [handleRequestErrorMixin, vbAttachmentTokenMixin],
    components: {
      BreakWordSpan,
      VbOutgoingDocSuaSaiBhDialog,
      TaskCreateDialog,
      HistoryDocout,
      VbdiLuongxulyWrapper,
      DocRelationsDetail,
      PhieuYKienDetail,
      VbdiDownloadFiles,
      FileTypeImage,
      DocOutSelectHandler: () => import("../components/DocOutSelectHandler.vue"),
      DocOutKetThuc,
      DocOutTuChoi,
      DocOutTuChoiBanHanh,
      BHanhDocOutDialog,
      CCDocOut,
      detailTemplate: () => import("../../common/detail.vue"),
      outgoingDocProcessThuHoiDialog: () =>
        import("../components/outgoingDocProcessThuHoiDialog"),
      outgoingDocThuHoiDialog: () =>
        import("../components/outgoingDocThuHoiDialog"),
      outgoingDocDBHThuHoiDialog: () =>
        import("../components/thuhoiBanHanhdialog"),
      VuePerfectScrollbar,
      listIconAction: () => import("../components/listIconActionDocs.vue"),
      DialogNoteInDocs: () => import("../../common/noteDocs/index")
    },

    filters: {dateFormatter, buildAttachmentURL, convertToLabelFilter},

    data() {
      return {
        steeringTypeLabel: null,
        isLawDocument: null,
        DOC_RELATION_ATTACHED_TYPE: constants.DOC_RELATION_ATTACHED_TYPE,
        DOC_RELATION_OBJECT_TYPE: constants.DOC_RELATION_OBJECT_TYPE,
        listImageChange: [],

        isOpenNoteInDocDialog: false,
        isEnableNoteInDocDialog: false,

        isOpenAddSignatureDialog: false,
        isEnableAddSignatureDialog: false,

        DOWNLOAD_OPTION: constants.DOWNLOAD_OPTION,
        settings: {maxScrollbarLength: 750},
        tabHistory: true,
        docRelationTypes: [],

        outgoingDoc: {},
        vbAttachment: {},
        attachmentMetadata: null,
        signatureFile: null,
        referenceOutgoingAttachment: null,
        docRelations: [],
        docReceivers: null,
        agencies: null,
        receiveOtherDepts: null,
        docReceiverIds: [],
        vbCommentObjectType: constants.COMMENT_OBJECT_TYPE.VB_DI,
        userVbOutgoingProcess: null,
        flowInstance: null,
        flowInstanceId: null,
        flowInstances: [],
        flowId: null,
        stepId: null,
        step: null,
        delegateInfo: null,

        isOpenDocOutSelectHandlerDialog: false,
        isEnableDocOutSelectHandlerDialog: false,
        isOpenDocOutKetThucDialog: false,
        isEnableDocOutKetThucDialog: false,

        isOpenDocOutTuChoiDialog: false,
        isEnableDocOutTuChoiDialog: false,

        isOpenDocOutTuChoiBHanhDialog: false,
        isEnableDocOutTuChoiBHanhDialog: false,

        isOpenDocOutCCDialog: false,
        isEnableDocOutCCDialog: false,

        isOpenOutgoingDocProcessThuHoiDialog: false,
        isEnableOutgoingDocProcessThuHoiDialog: false,
        isOpenOutgoingDocThuHoiDialog: false,
        isEnableOutgoingDocThuHoiDialog: false,
        isOpenOutgoingDocDBHThuHoiDialog: false,
        isEnableOutgoingDocDBHThuHoiDialog: false,
        isOpenBHanhDocOut: false,
        isEnableBHanhDocOut: false,
        outgoingAttachmentURL: null, //link download nguyen goc;
        outgoingAttachmentForVanThuURL: null, //link download co chu ky khong co watermark;
        referenceOutgoingAttachmentURL: null, //link download co chu ky kem watermark;
        referenceOutgoingAttachmentURL2: null, //link download trc khi ban hanh co kem watermark;

        isOpenCreateJobDialog: false,
        isEnableCreateJobDialog: false,
        TASK_TASK_TYPE: constants.TASK_TASK_TYPE,
        JOB_INDEX_PAGE: constants.JOB_INDEX_PAGE,
        giaoViecMenuConfig: null,
        DOC_TYPE: constants.DOC_TYPE,
        OUTGOING_DOC_STATUS: constants.OUTGOING_DOC_STATUS,

        isOpenSuaSaiDialog: false,
        isEnableSuaSaiDialog: false,
        categoryCode: null
      };
    },

    computed: {
      //xác định xem văn bản có phải đã bị "xóa" không ?
      isAchievement() {
        return this.outgoingDoc.isAchievement;
      },

      signerName() {
        if (this.outgoingDoc) {
          return this.outgoingDoc.signerUserDeptRoleId
            ? `${this.outgoingDoc.signerName} (${
              this.outgoingDoc.signerPosName
            } ${this.outgoingDoc.signerDeptName})`
            : this.outgoingDoc.signerName;
        } else {
          return null;
        }
      },

      isKyNgoai() {
        return (
          this.outgoingDoc &&
          this.outgoingDoc.isKyNgoai === constants.OUTGOING_DOC.IS_KY_NGOAI.TRUE
        );
      },

      userVbOutgoingProcessId() {
        return this.$route.query.vbDocProcessId;
      },

      parentRoute() {
        return this.$route.path.split("/")[3];
      },

      userId() {
        return this.$store.getters.user.id;
      },

      roleCode() {
        return this.$store.getters.userDeptRole.roleCode;
      },

      deptId() {
        return this.$store.getters.userDeptRole.deptId;
      },

      publisherId() {
        return this.outgoingDoc ? this.outgoingDoc.publisherId : null;
      },

      /**
       * có thể thu hồi bởi người thực hiện chuyển xử lý;
       * @returns {boolean|outgoingDoc|{}}
       */
      canOutGoingProcessThuHoi() {
        return (
          this.userVbOutgoingProcess &&
          this.userVbOutgoingProcess.status ==
          constants.OUTGOING_PROCESS_STATUS.DA_XU_LY &&
          this.outgoingDoc &&
          this.outgoingDoc.status == constants.OUTGOING_DOC_STATUS.DANGXULI
        );
      },

      /**
       * có thể thu thồi bởi người ban hành;
       * @returns {boolean|outgoingDoc|{}}
       */
      canOutoingDocThuHoi() {
        return (
          !this.userVbOutgoingProcessId &&
          this.outgoingDoc &&
          this.outgoingDoc.creatorId == this.userId &&
          constants.OUTGOING_DOC_STATUS.DANGXULI == this.outgoingDoc.status
        );
      },
      /**
       * thu hồi vb đã ban hành;
       * @returns {boolean|outgoingDoc|{}}
       */
      canOutoingDocDBHThuHoi() {
        return (
          this.roleCode == "vanthu" &&
          constants.OUTGOING_DOC_STATUS.DABANHANH == this.outgoingDoc.status
        );
      },

      id() {
        return this.$route.params.id;
      },
      docStatus() {
        return this.outgoingDoc ? this.outgoingDoc.status : null;
      },

      attachmenttURLForChuyenVien() {
        return [
          constants.OUTGOING_DOC_STATUS.CHO_BAN_HANH,
          constants.OUTGOING_DOC_STATUS.DABANHANH
        ].indexOf(this.docStatus)
          ? this.referenceOutgoingAttachmentURL ||
          this.referenceOutgoingAttachmentURL2
          : this.referenceOutgoingAttachmentURL2;
      },

      userDeptRoleId() {
        return this.$route.params.userDeptRoleId;
      },

      isViewAsUyQuyen() {
        return (
          this.delegateInfo &&
          this.delegateInfo.fromUserDeptRoleId == this.userDeptRoleId
        );
      },

      isEnableGiaoViec() {
        return (
          this.giaoViecMenuConfig !== null &&
          this.docStatus === constants.OUTGOING_DOC_STATUS.DABANHANH
        );
      },

      isEnableExportTiepNhanVanBanReport() {
        return (
          this.roleCode === constants.ROLE.CODE.VAN_THU &&
          this.outgoingDoc &&
          this.outgoingDoc.status === constants.OUTGOING_DOC_STATUS.DABANHANH
        );
      },

      isBanHanhTrucLienThong() {
        return this.agencies && this.agencies.length;
      },

      blockedUserId() {
        return this.$store.getters.lockedUserDeptRole.userId
      }
    },

    mounted() {
      EventBus.$on("hieuChinhSuccess", options => {
        this.loadDocInfo();
        this.loadDocRelationsDetail();
      });
    },

    watch: {
      userVbOutgoingProcessId(newValue) {
        if (newValue) {
          this.loadUserVbOutgoingProcess();
        } else {
          this.userVbOutgoingProcess = null;
          this.flowInstanceId = null;
          this.stepId = this.userVbOutgoingProcess.stepId;
          this.step = null;
          this.flowInstance = null;
          this.flowId = null;
        }

        this.buildOutgoingAttachmentURL();
      },

      isOpenOutgoingDocProcessThuHoiDialog(newValue) {
        newValue && (this.isEnableOutgoingDocProcessThuHoiDialog = newValue);
      },
      isOpenOutgoingDocThuHoiDialog(newValue) {
        newValue && (this.isEnableOutgoingDocThuHoiDialog = newValue);
      },
      isOpenOutgoingDocDBHThuHoiDialog(newValue) {
        newValue && (this.isEnableOutgoingDocDBHThuHoiDialog = newValue);
      },
      isOpenDocOutKetThucDialog(newValue) {
        newValue && (this.isEnableDocOutKetThucDialog = newValue);
      },
      isOpenBHanhDocOut(newValue) {
        newValue && (this.isEnableBHanhDocOut = newValue);
      },
      isOpenDocOutSelectHandlerDialog(newValue) {
        newValue && (this.isEnableDocOutSelectHandlerDialog = newValue);
      },
      isOpenDocOutCCDialog(newValue) {
        newValue && (this.isEnableDocOutCCDialog = newValue);
      },
      isOpenDocOutTuChoiDialog(newValue) {
        newValue && (this.isEnableDocOutTuChoiDialog = newValue);
      },
      isOpenDocOutTuChoiBHanhDialog(newValue) {
        newValue && (this.isEnableDocOutTuChoiBHanhDialog = newValue);
      },
      isOpenNoteInDocDialog(newValue) {
        newValue && (this.isEnableNoteInDocDialog = newValue);
      },
      isOpenAddSignatureDialog(newValue) {
        newValue && (this.isEnableAddSignatureDialog = newValue);
      },
      isOpenSuaSaiDialog(newValue) {
        newValue && (this.isEnableSuaSaiDialog = newValue);
      },
      vbAttachment(newValue) {
        this.buildOutgoingAttachmentURL();
        this.buildReferenceOutgoingAttachmentURL2();
        this.loadAttachmentMetadata();
      },
      referenceOutgoingAttachment() {
        this.buildReferenceOutgoingAttachmentURL();
        this.buildOutgoingAttachmentForVanThuURL();
      },
      id() {
        this.loadDocInfo();
        this.loadReferenceOutgoingAttachment();
      },
      isOpenCreateJobDialog(newValue) {
        newValue && (this.isEnableCreateJobDialog = newValue);
      }
    },

    created() {
      this.loadCategories();
      this.loadDocInfo();
      this.loadReferenceOutgoingAttachment();
      this.initForGiaoViecButton();
    },

    methods: {
      downloadDoc(attachment) {
        console.log('attachment.type:', attachment.objectType)
        switch (attachment.objectType) {
          case constants.ATTACHMENT_OBJECT_TYPE.VB_DI_REFERENCE_ATTACHMENT:
            return this.roleCode === constants.ROLE.CODE.VAN_THU
              ? downloadService.downloadReferenceOutgoingDocForVTForBlockedRole(attachment.objectId, this.blockedUserId)
              : downloadService.downloadReferenceOutgoingDocForBlockedRole(attachment.objectId, this.blockedUserId);
          case constants.ATTACHMENT_OBJECT_TYPE.VB_DI:
            return this.roleCode === constants.ROLE.CODE.VAN_THU
              ? downloadService.downloadOutgoingDocForVTBlockedRole(attachment.objectId, this.blockedUserId)
              : downloadService.downloadOutgoingDocForBlockedRole(attachment.objectId, this.blockedUserId);
          case constants.ATTACHMENT_OBJECT_TYPE.VB_DI_SIGNED_WITH_TOKEN:
          case constants.ATTACHMENT_OBJECT_TYPE.VB_DI_SIGNED_WITH_TOKEN_WITHOUT_STAMP:
            return this.roleCode === constants.ROLE.CODE.VAN_THU
              ? downloadService.downloadOutgoingDocWithTokenForVTBlockedRole(
                attachment.objectId,
                attachment.objectType,
                this.blockedUserId
              )
              : downloadService.downloadOutgoingDocWithTokenForBlockedRole(
                attachment.objectId,
                attachment.objectType,
                this.blockedUserId
              );
          default:
            break;
        }
      },

      downloadOriginDoc(attachment) {
        switch (attachment.objectType) {
          case constants.ATTACHMENT_OBJECT_TYPE.VB_DI:
            return this.roleCode === constants.ROLE.CODE.VAN_THU
              ? downloadService.downloadOutgoingDocForVTBlockedRole(attachment.objectId, this.blockedUserId)
              : downloadService.downloadOutgoingDocWithoutTrangKySoAndWithoutWaterMarkForBlockedRole(attachment.objectId, this.blockedUserId);
          case constants.ATTACHMENT_OBJECT_TYPE.VB_DI_SIGNED_WITH_TOKEN:
            // Cho phép các role khác văn thư nhưng nằm trong luồng VB có thể xem văn bản gốc
            downloadService.downloadOutgoingDocWithTokenForVTBlockedRole(
              attachment.objectId,
              attachment.objectType,
              this.blockedUserId
            )
            break;
          default:
            break;
        }
      },

      suaSaiSuccess(event) {
        this.isOpenSuaSaiDialog = false;
        this.backModel();
        EventBus.$emit(this.parentRoute, {});
      },
      permanentDelete() {
        utils
          .confirm(
            this.$confirm,
            errorMessageFilter({
              errorCode: "vbOutgoingDoc.permanentDelete.confirm"
            })
          )
          .then(() => {
            return outgoingDocService.permanentDelete(this.id).then(() => {
              this.$message.success(
                errorMessageFilter({
                  errorCode: "vbOutgoingDoc.permanentDelete.success"
                })
              );
              this.commonAfterSuccess();
            });
          })
          .catch(error => this.commonHandleRequestError(error));
      },

      restore() {
        utils
          .confirm(
            this.$confirm,
            errorMessageFilter({
              errorCode: "vbOutgoingDoc.restore.confirm"
            })
          )
          .then(() => {
            return outgoingDocService.restore(this.id).then(() => {
              this.$message.success(
                errorMessageFilter({
                  errorCode: "vbOutgoingDoc.restore.success"
                })
              );
              this.commonAfterSuccess();
            });
          })
          .catch(error => this.commonHandleRequestError(error));
      },

      initSteeringTypeLabel() {
        switch (this.outgoingDoc.steeringType) {
          case constants.STEERING_TYPE.KHONGPHAICHIDAO:
            this.steeringTypeLabel = errorMessageFilter({
              errorCode: "steeringType.label.khongphaichidao"
            });
            break;
          case constants.STEERING_TYPE.CHIDAO:
            this.steeringTypeLabel = errorMessageFilter({
              errorCode: "steeringType.label.chidao"
            });
            break;
          case constants.STEERING_TYPE.BAOCAOCHIDAO:
            this.steeringTypeLabel = errorMessageFilter({
              errorCode: "steeringType.label.baocaochidao"
            });
            break;
        }
      },

      delete_() {
        this.$confirm(
          `Bạn có muốn xóa văn bản "${this.outgoingDoc.quote}" ?`,
          "Thông báo",
          {
            confirmButtonText: "Xác nhận",
            cancelButtonText: "Hủy bỏ",
            type: "warning"
          }
        ).then(() => {
          outgoingDocService
            .deleteForVanThu(this.id)
            .then(() => {
              this.$message({
                message: "Xóa văn bản thành công",
                type: "success"
              });
              this.commonAfterSuccess();
            })
            .catch(error => this.commonHandleRequestError(error));
        });
      },
      exportTiepNhanVanBanReport() {
        utils.exportReport(constants.REPORT.TIEPNHANVANBAN.REPORT_URL, {
          userDeptRoleId: this.userDeptRoleId,
          docId: this.id,
          docType: constants.DOC_TYPE.VB_DI
        });
      },

      initForGiaoViecButton() {
        return menuConfigService
          .findAll({
            userDeptRoleId: this.userDeptRoleId,
            menuCode: constants.MENU_LIST.CONGVIEC_GIAO,
            status: constants.MENU_CONFIG.STATUS.ACTIVE
          })
          .then(response => {
            let menuConfigs = response.data;
            return (this.giaoViecMenuConfig =
              menuConfigs && menuConfigs.length ? menuConfigs[0] : null);
          });
      },

      createTaskSuccess() {
        this.isOpenCreateJobDialog = false;
      },

      openGiaoViecDialog() {
        this.isOpenCreateJobDialog = true;
      },

      loadAttachmentMetadata() {
        if (this.vbAttachment && this.vbAttachment.id) {
          attachmentService
            .getAttachmentMetadata(this.vbAttachment.id)
            .then(response => {
              this.attachmentMetadata = response.data;
            });
        } else {
          this.attachmentMetadata = null;
        }
      },

      loadReferenceOutgoingAttachment() {
        attachmentService
          .findReferenceOutgoingAttachment(this.id)
          .then(response => (this.referenceOutgoingAttachment = response.data));
      },

      /**
       * link download cho chuyen vien sau khi ban hanh;
       */
      buildReferenceOutgoingAttachmentURL() {
        if (this.referenceOutgoingAttachment) {
          vbAttachmentTokenService
            .getTokenForReferenceOutgoingAttachmentForBlockedRole(
              this.referenceOutgoingAttachment.id,
              this.blockedUserId
            )
            .then(response => {
              let token = response.data.token;
              this.referenceOutgoingAttachmentURL = buildAttachmentURL(token, {
                downloadFileURL:
                constants.DOWNLOAD_FILE_URL.REFERENCE_OUTGOING_URL
              });
            });
        } else {
          this.referenceOutgoingAttachmentURL = null;
        }
      },

      buildReferenceOutgoingAttachmentURL2() {
        if (this.vbAttachment) {
          vbAttachmentTokenService
            .getTokenForBlockedRole(this.vbAttachment.id, this.blockedUserId)
            .then(response => {
              let token = response.data.token;
              this.referenceOutgoingAttachmentURL2 = buildAttachmentURL(token, {
                type: constants.DOWNLOAD_OPTION.TYPE.PDF,
                downloadFileURL: constants.DOWNLOAD_FILE_URL.OUTGOING_URL
              });
            });
        } else {
          this.referenceOutgoingAttachmentURL2 = null;
        }
      },

      /**
       * link download khong co watermark;
       */
      buildOutgoingAttachmentForVanThuURL() {
        if (this.referenceOutgoingAttachment) {
          vbAttachmentTokenService
            .getTokenForReferenceOutgoingAttachmentForBlockedRole(
              this.referenceOutgoingAttachment.id,
              this.blockedUserId
            )
            .then(response => {
              let token = response.data.token;
              this.outgoingAttachmentForVanThuURL = buildAttachmentURL(token, {
                type: constants.DOWNLOAD_OPTION.TYPE.ORIGINAL,
                downloadFileURL: constants.DOWNLOAD_FILE_URL.DEFAULT_URL
              });
            });
        } else {
          this.outgoingAttachmentForVanThuURL = null;
        }
      },

      /**
       * link download nguyen goc;
       */
      buildOutgoingAttachmentURL() {
        if (this.vbAttachment) {
          vbAttachmentTokenService
            .getTokenForBlockedRole(this.vbAttachment.id, this.blockedUserId)
            .then(response => {
              let token = response.data.token;
              this.outgoingAttachmentURL = buildAttachmentURL(token, {
                type: constants.DOWNLOAD_OPTION.TYPE.ORIGINAL,
                downloadFileURL: constants.DOWNLOAD_FILE_URL.DEFAULT_URL
              });
            });
        } else {
          this.outgoingAttachmentURL = null;
        }
      },

      addSignatureSuccess() {
        this.isOpenAddSignatureDialog = false;
        this.loadDocInfo();
        this.loadReferenceOutgoingAttachment();
      },

      populateListImageDoc(listImage) {
        let listImageModify = [];
        h.each(listImage, item => {
          if (item.isModify) {
            listImageModify.push({
              base64: item.base64,
              pageNumber: item.id,
              vbAttachmentId: this.vbAttachment.id
            });
          }
        });
        return listImageModify;
      },

      finishNoteDoc(listImage) {
        this.listImageChange = this.populateListImageDoc(listImage);
        this.tuChoi();
      },

      hieuChinhVb() {
        this.$router.push({
          name: "vbChoBanHanhHieuChinh",
          params: {
            userDeptRoleId: this.$route.params.userDeptRoleId,
            id: this.id
          },
          query: this.$route.query
        });
      },

      suaSaiBanHanh() {
        this.isOpenSuaSaiDialog = true;
      },

      loadVbFlowInstance() {
        vbFlowInstanceService
          .findAll(
            {docId: this.id},
            {page: 0, size: 10, sort: "updateTime,asc"}
          )
          .then(response => {
            this.flowInstances = response.data.map((item, index) => {
              return {
                id: item.id,
                updateTime: item.updateTime,
                isActive: index == response.data.length - 1
              };
            });
          });
      },

      outGoingProcessThuHoiSuccess() {
        this.isOpenOutgoingDocProcessThuHoiDialog = false;
      },

      openTabHistory() {
        this.tabHistory = true;
      },

      closeTabHistory() {
        this.tabHistory = false;
      },

      getRelationTypeLabel(relationType) {
        var docRelationType = h.find(
          this.docRelationTypes,
          docRelationType => docRelationType.id == relationType
        );

        return docRelationType ? docRelationType.categoryName : null;
      },

      loadCategories() {
        h.each([constants.CATEGORY_GROUP_CODE.DOC_RELATION_TYPE], item => {
          categoryViewService
            .findAll({groupCode: item}, {page: 0, size: 1000})
            .then(response => {
              switch (item) {
                case constants.CATEGORY_GROUP_CODE.DOC_RELATION_TYPE:
                  return (this.docRelationTypes = response.data);
              }
            });
        });
      },

      openCCDialog() {
        this.isOpenDocOutCCDialog = true;
      },

      tuChoi() {
        this.isOpenDocOutTuChoiDialog = true;
      },

      tuChoiBHanh() {
        this.isOpenDocOutTuChoiBHanhDialog = true;
      },

      banHanhSuccess(event) {
        this.isOpenDocOutKetThucDialog = false;
        this.userVbOutgoingProcess = event.vbOutgoingProcess;
        this.backModel();
        EventBus.$emit(this.parentRoute, {});
      },

      tuChoiSuccess() {
        this.isOpenDocOutTuChoiDialog = false;
        this.isOpenNoteInDocDialog = false;
        this.backModel();
        EventBus.$emit(this.parentRoute, {});
      },

      tuChoiBHanhSuccess() {
        this.isOpenDocOutTuChoiBHanhDialog = false;
        this.backModel();
        EventBus.$emit(this.parentRoute, {});
      },

      banHanhVanThuSuccess() {
        this.isOpenBHanhDocOut = false;
        this.commonAfterSuccess();
      },

      ccSuccess() {
        this.isOpenDocOutCCDialog = false;
        this.backModel();
        this.commonAfterSuccess();
      },

      commonAfterSuccess() {
        EventBus.$emit(this.parentRoute, {});
        this.backModel();
      },

      docOutKetThucDialogClosed() {
        if (this.isBanHanhSuccess) {
          this.message(
            "Thông báo",
            "Ban hành văn bản thành công.",
            "success",
            4000
          );

          this.backModel();

          this.loadDocInfo();

          EventBus.$emit(this.parentRoute, {});
        }
      },

      docOutTuChoiDialogClosed() {
        if (this.isTuChoiSuccess) {
          this.message(
            "Thông báo",
            "Từ chối văn bản thành công.",
            "success",
            3000
          );

          this.backModel();

          this.loadDocInfo();

          EventBus.$emit(this.parentRoute, {});
        }
      },

      isEnableChuyenXuLi() {
        return (
          this.isChoXuLy() &&
          this.step &&
          this.step.posType != constants.STEP_POS_TYPE.KET_THUC &&
          this.step.posType != constants.STEP_POS_TYPE.BOTH
        );
      },

      isTuChoi() {
        return this.outgoingDoc.status == constants.OUTGOING_DOC_STATUS.TU_CHOI;
      },

      isChoXuLy() {
        return (
          this.userVbOutgoingProcess &&
          this.userVbOutgoingProcess.status ==
          constants.OUTGOING_PROCESS_STATUS.CHO_XU_LY
        );
      },

      isTaoMoi() {
        return (
          this.outgoingDoc &&
          this.outgoingDoc.status == constants.OUTGOING_DOC_STATUS.TAOMOI
        );
      },

      isEnableKetThuc() {
        return (
          this.isChoXuLy() &&
          this.step &&
          (this.step.posType == constants.STEP_POS_TYPE.KET_THUC ||
            this.step.posType == constants.STEP_POS_TYPE.BOTH)
        );
      },
      isEnableThuHoi() {
        return (
          this.isChoXuLy() &&
          this.step &&
          (this.step.posType == constants.STEP_POS_TYPE.KET_THUC ||
            this.step.posType == constants.STEP_POS_TYPE.BOTH)
        );
      },

      isEnableBanHanh() {
        return (
          this.roleCode == "vanthu" &&
          this.outgoingDoc &&
          (this.outgoingDoc.status ==
            constants.OUTGOING_DOC_STATUS.CHO_BAN_HANH ||
            this.outgoingDoc.status == constants.OUTGOING_DOC_STATUS.DABANHANH)
        );
      },
      isEnableTuChoiBanHanh() {
        return (
          this.flowInstances.length &&
          this.roleCode == "vanthu" &&
          this.outgoingDoc &&
          this.outgoingDoc.status == constants.OUTGOING_DOC_STATUS.CHO_BAN_HANH
        );
      },

      isEnableHieuChinh() {
        return (
          this.roleCode == "vanthu" &&
          this.outgoingDoc &&
          this.outgoingDoc.status == constants.OUTGOING_DOC_STATUS.CHO_BAN_HANH
        );
      },

      isEnableSuaSaiBanHanh() {
        return (
          this.roleCode == "vanthu" &&
          this.outgoingDoc &&
          this.outgoingDoc.status == constants.OUTGOING_DOC_STATUS.DABANHANH
        );
      },

      isEnableThemChuKy() {
        return (
          this.roleCode == "vanthu" &&
          this.attachmentMetadata &&
          this.outgoingDoc &&
          (this.outgoingDoc.status ==
            constants.OUTGOING_DOC_STATUS.CHO_BAN_HANH ||
            this.outgoingDoc.status == constants.OUTGOING_DOC_STATUS.DABANHANH)
        );
      },
      isEnableDelete() {
        return (
          this.outgoingDoc &&
          this.outgoingDoc.isKyNgoai == constants.OUTGOING_DOC.IS_KY_NGOAI.TRUE &&
          this.outgoingDoc.status == constants.OUTGOING_DOC_STATUS.CHO_BAN_HANH &&
          this.outgoingDoc.publisherId ==
          this.$store.getters.userDeptRole.deptId &&
          this.$store.getters.userDeptRole.roleCode == constants.ROLE.CODE.VAN_THU
        );
      },

      isEnableCC() {
        return (
          this.outgoingDoc &&
          this.outgoingDoc.status == constants.OUTGOING_DOC_STATUS.DABANHANH
        );
      },

      chuyenXuLiSuccess() {
        this.isOpenDocOutSelectHandlerDialog = false;

        this.message(
          "Thông báo",
          this.step && this.step.signType == 2
            ? "Ký số và chuyển xử lý văn bản thành công "
            : "Chuyển xử lý văn bản thành công ",
          "success",
          4000
        );

        EventBus.$emit(this.parentRoute, {});
        this.backListPage();
      },

      loadDocReceivers_(objectType) {
        return vbOutgoingDocReceiversService
          .findAll(
            {docId: this.id, objectType: objectType},
            {sort: "objectType", page: 0, size: 1000}
          )
          .then(response => response.data);
      },

      loadDocReceivers() {
        return this.loadDocReceivers_(constants.RECEIVER_OBJECT_TYPE.DONVI).then(
          docReceivers => {
            this.docReceivers = docReceivers;
            this.docReceiverIds = h.collect(
              docReceivers,
              docReceiver => docReceiver.objectId
            );
          }
        );
      },

      loadAgencies() {
        return this.loadDocReceivers_(
          constants.RECEIVER_OBJECT_TYPE.DONVI_TRUCLIENTHONG
        ).then(agencies => (this.agencies = agencies));
      },

      loadReceiveOtherDepts() {
        return this.loadDocReceivers_(
          constants.RECEIVER_OBJECT_TYPE.DONVI_BENNGOAI
        ).then(docReceivers => (this.receiveOtherDepts = docReceivers));
      },

      loadUserVbOutgoingProcess() {
        if (this.userVbOutgoingProcessId) {
          vbOutgoingProcessService
            .findById(this.userVbOutgoingProcessId)
            .then(response => {
              this.userVbOutgoingProcess = response.data;
              this.flowInstanceId = this.userVbOutgoingProcess.flowInstanceId;
              this.stepId = this.userVbOutgoingProcess.stepId;
              vbStepService
                .findById(this.stepId)
                .then(response => (this.step = response.data));
              if (this.userVbOutgoingProcess.delegateInfoId) {
                vbDelegateInfoService
                  .findById(this.userVbOutgoingProcess.delegateInfoId)
                  .then(response => (this.delegateInfo = response.data));
              } else {
                this.delegateInfo = null;
              }
              vbFlowInstanceService
                .findById(this.flowInstanceId)
                .then(response => {
                  this.flowInstance = response.data;
                  this.flowId = this.flowInstance.flowId;
                });
              // this.markAsRead();
            });
        }
      },

      loadDocRelationsDetail() {
        this.$refs.docRelationsNoAttachedDetail.loadRelationDocs();
        this.$refs.docRelationsAttachedDetail.loadRelationDocs();
      },

      modelBack() {
        this.$router.back();
      },

      getSecurityClass(id) {
        return constants.HIGH_LEVELS_SECURITY_IDS.indexOf(id) != -1
          ? "lv1"
          : "lv4";
      },

      getPriorityClass(id) {
        return constants.HIGH_LEVELS_PIORITY_IDS.indexOf(id) != -1
          ? "lv1"
          : "lv4";
      },

      backModel() {
        this.$router.push({name: this.parentRoute, params: this.$route.params});
      },

      maskAsRead() {
        outgoingDocService
          .maskAsRead(this.id, this.userVbOutgoingProcessId)
          .catch(error => this.commonHandleRequestError(error));
      },

      loadDocInfo() {
        outgoingDocService
          .findByIdForBlockedRole(this.id, this.blockedUserId)
          .then(response => {
            this.outgoingDoc = response.data;
          })
          .then(() => {
            this.isLawDocument =
              this.outgoingDoc.isLawDocument === constants.TRUE;
            this.initSteeringTypeLabel();
          })
          .then(() => this.maskAsRead());

        attachmentService
          .findAll({
            objectId: this.id,
            objectType: constants.ATTACHMENT_OBJECT_TYPE.VB_DI
          })
          .then(response => {
            if (response.data && response.data.length) {
              this.vbAttachment = response.data[0];
            }
          });

        attachmentService
          .findAll(
            {
              objectId: this.id,
              objectType:
              constants.ATTACHMENT_OBJECT_TYPE.VB_DI_SIGNED_WITH_TOKEN
            },
            {sort: "createTime,desc", page: 0, size: 1}
          )
          .then(response => {
            if (response.data && response.data.length) {
              this.signatureFile = response.data[0];
            } else this.signatureFile = null;
          });

        docRelationService.findAll({objectId: this.id}).then(response => {
          this.docRelations = response.data;
        });

        this.loadUserVbOutgoingProcess();
        this.loadDocReceivers();
        this.loadReceiveOtherDepts();
        this.loadAgencies();
        this.loadVbFlowInstance();
      },

      backListPage() {
        let namePageBack = this.$route.path.split("/");
        this.$router.push({
          name: `${namePageBack[3]}`,
          query: this.$route.query,
          params: this.$route.params
        });
      }
    },
    destroyed() {
      EventBus.$off("hieuChinhSuccess");
      document.removeEventListener("keyup", this.escapeKeyListener);
    }
  };
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/views/doc-out/locked-role/Detail.vue